import Component from 'D:/HBuilderProjects/园博园/uni_modules/atl-map/components/atl-map/atl-map.vue'
wx.createComponent(Component)